export class ActionLogToken {
  static IActionLogRepository = Symbol("IActionLogRepository");
  static ActionLogUseCase = Symbol("ActionLogUseCase");
  static ActionLogViewModel = Symbol("ActionLogViewModel");
}
